var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3348 20.3889C10.2962 20.3904 10.2577 20.3904 10.2207 20.3919C10.2592 20.3904 10.2978 20.3904 10.3348 20.3889Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.98047 20.3932C9.99588 20.3932 10.0128 20.3932 10.0282 20.3932C10.0791 20.3932 10.1284 20.3932 10.1793 20.3917C10.1284 20.3917 10.0791 20.3932 10.0282 20.3932C10.0128 20.3932 9.99588 20.3932 9.98047 20.3932Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0295 0.394073C4.48993 0.394073 0 4.8707 0 10.3939C0 15.791 4.28801 20.1878 9.65189 20.3875C9.10933 20.3676 8.57757 20.3046 8.05968 20.2016V12.5869H6.42277V9.8683H8.05814V8.23624C8.05814 6.01868 8.9814 4.70012 11.6063 4.70012H13.7904V7.41868H12.4248C11.4029 7.41868 11.335 7.79826 11.335 8.50826L11.3319 9.8683H13.8058L13.516 12.5869H11.3319V20.3107C11.0622 20.346 10.7925 20.3691 10.5212 20.3829C15.8311 20.1263 20.0575 15.7526 20.0575 10.3954C20.059 4.8707 15.5691 0.394073 10.0295 0.394073Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.81445 20.3917C9.84374 20.3917 9.87302 20.3932 9.90231 20.3932C9.87302 20.3917 9.84374 20.3917 9.81445 20.3917Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.66211 20.387C9.6991 20.3885 9.73763 20.3901 9.77463 20.3901C9.73763 20.3885 9.70064 20.3885 9.66211 20.387Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5106 20.3832C10.4659 20.3848 10.4197 20.3878 10.375 20.3894C10.4197 20.3863 10.4644 20.3848 10.5106 20.3832Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookW);
export default __webpack_public_path__ + "static/media/facebook-w.f477b29e06a077d9e0371610f253858e.svg";
export { ForwardRef as ReactComponent };